module.exports = __webpack_public_path__ + "img/Img1.f7542812.jpg";